// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_Lm4Vt){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_3YNwX .dualColumn_3C_Fq{display:flex;align-content:space-between}.nsAddressForm_3YNwX .dualColumn_3C_Fq .firstCol_he5FH{margin-right:20px}.optional_10Oa8{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_Lm4Vt",
	"nsAddressForm": "nsAddressForm_3YNwX",
	"dualColumn": "dualColumn_3C_Fq",
	"firstCol": "firstCol_he5FH",
	"optional": "optional_10Oa8"
};
module.exports = exports;
